// Showreel: scroll-scale animation (grows from scale 0.5 to 1 into view)
// plus a play button that opens the video in a Fancybox popup.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/** Grow each .showreel from scale 0.5 to 1 as it scrolls in, scrubbed to the scroll position. */
function initScaleOnScroll() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Only the hero showreel, or a lone showreel that's the only video in its
  // group, scales — showreels inside a column or reused elsewhere stay static.
  document.querySelectorAll('.showreel').forEach((el) => {
    const inHero = el.closest('.hero');
    const inColumn = el.closest('.wp-block-column');
    const group = el.closest('.wp-block-group');
    const loneInGroup =
      group && group.querySelectorAll('.showreel').length === 1;

    const shouldAnimate = inHero || (loneInGroup && !inColumn);
    if (!shouldAnimate) return;

    gsap.fromTo(
      el,
      { scale: 0.5 },
      {
        scale: 1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          // Begin only as the block scrolls into view from the bottom,
          // finish once it reaches the middle of the viewport.
          start: 'top bottom',
          end: 'center center',
          scrub: 0.3,
        },
      }
    );
  });
}

// Bind play buttons to Fancybox. Fancybox v5 is enqueued globally (see functions.php) and
// auto-detects YouTube URLs in the anchor href.
function initPopup() {
  if (window.Fancybox) {
    window.Fancybox.bind('[data-fancybox]', {});
  }
}

export default function initShowreel() {
  if (!document.querySelector('.showreel')) return;
  initScaleOnScroll();
  initPopup();
}
